"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPhoneE164 = void 0;
const only_digits_1 = require("../only-digits/only-digits");
/**
 * Convert a phone number to E.164 format
 * @public
 *
 * @param phone - An unformatted phone number string
 *
 * @returns phone number in E.164 format
 *
 * @example
 * ```ts
 * cont result = toPhoneE164('212-555-9656');
 * console.log(result);
 * // -> '+12125559656'
 * ```
 */
function toPhoneE164(phone) {
    return `+1${(0, only_digits_1.onlyDigits)(phone)}`;
}
exports.toPhoneE164 = toPhoneE164;
//# sourceMappingURL=to-phone-E164.js.map